import { Component } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Message, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { Gender } from 'src/app/demo/enums/gender';
import {
    DriverProfile,
    DriverSummary,
} from 'src/app/demo/models/common-data-types';
import { DateValidationObject } from 'src/app/demo/models/validate-date';
import { CustomToastrService } from 'src/app/demo/service/custom-toastr.service';
import { DriversService } from 'src/app/demo/service/drivers.service';
import { ProgressLoaderService } from 'src/app/demo/service/progress-loader.service';
import { validateDate } from 'src/app/demo/utilities/date-validators';
import { mapToEditDriver } from 'src/app/demo/utilities/driver-utils';

@Component({
    selector: 'app-update-driver',
    standalone: true,
    imports: [
        ButtonModule,
        CardModule,
        DropdownModule,
        CalendarModule,
        MessagesModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
    ],
    templateUrl: './update-driver.component.html',
    styleUrl: './update-driver.component.scss',
    providers: [MessagesModule],
})
export class UpdateDriverComponent {
    genderTypes: any[] = [
        { name: 'Male', value: Gender.Male },
        { name: 'Female', value: Gender.Female },
    ];
    dateValidator: DateValidationObject = validateDate(16);
    messages: Message[] = [];
    driverForm!: FormGroup;
    id!: string;
    driver!: DriverProfile;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private progressLoader: ProgressLoaderService,
        private driverService: DriversService,
        private wiseToastr: CustomToastrService,
        private messageService: MessageService,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.initializeForm();
        this.getDriverId();
    }

    getDriverId() {
        this.route.params.subscribe((params) => {
            this.id = params['id'];
            this.fetchDriverProfile();
        });
    }

    initializeForm() {
        this.driverForm = this.fb.group({
            firstname: [''],
            surname: [''],
            dateOfBirth: [null],
            gender: [null],
        });
    }

    fetchDriverProfile() {
        this.progressLoader.show('Fetching driver profile');
        this.driverService.getDriverDetails(this.id).subscribe({
            next: (value) => {
                this.driver = value;
                this.progressLoader.hide();
                this.patchDriversForm();
            },
            error: (err) => {
                this.showErrorToast(this.translate.instant(err.error.messageKey))
            },
        });
    }

    patchDriversForm() {
        this.patchDriverFormControl('firstname', this.driver.driver.firstname);
        this.patchDriverFormControl('surname', this.driver.driver.surname);
        this.patchDriverFormControl(
            'dateOfBirth',
            this.convertDateFormat(this.driver.driver.dateOfBirth)
        );
        this.patchDriverFormControl('gender', this.driver.driver.gender);
    }

    patchDriverFormControl(controlName: string, value: any) {
        if (this.driverForm.contains(controlName)) {
            this.driverForm.get(controlName)?.patchValue(value);
        } else {
            console.error(`Control ${controlName} does not exist in the form.`);
        }
    }

    convertDateFormat(dateString: string): string {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    }

    showSuccessToast(message: string) {
        this.wiseToastr.showSuccess(message)
    }

    showErrorToast(message: string) {
        this.wiseToastr.showError(message)
    }

    clearForm() {
        this.driverForm.reset();
    }

    saveDriverDetails() {}
}
